<template>
  <v-container id="bid-costs" fluid tag="section" class="main-container">
    <idc-component-bid-costings
      show-history-of-costings
      :bid-number="bidNumber"
      :settings="settings"
      :specifications="specifications"
      :center-coordinates="centerCoordinates"
      :summary="summary"
      :calculated="calculated"
      :totals="totals"
      :base-url="path.SALES_BIDS_COST"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState, mapMutations } from 'vuex'
  import BidNumber from '@/utilities/bid/BidNumber'
  import RouteQuery from '@/utilities/core/route/RouteQuery'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardBidCostings',
    components: {
      IdcComponentBidCostings: () => import('@/components/idc/bids/cost/Costings'),
    },
    data: () => ({
      path: Path,
    }),
    computed: {
      ...mapState('Settings', ['settings']),
      ...mapState('Bid', ['specifications', 'bidNumber', 'centerCoordinates', 'summary']),
      ...mapState('Bid/Cost', ['calculated', 'totals']),
    },
    mounted() {
      this.resetAll()
      this.initBidNumber()
    },
    methods: {
      ...mapActions('Bid', ['fetchSpecifications', 'fetchSummary']),
      ...mapActions('Bid/Cost', ['fetchCostings']),
      ...mapMutations('Bid/Cost', ['resetAll']),
      initBidNumber() {
        const bidNumber = new BidNumber()
        const num = RouteQuery.bidNumber(this.$router) ?? this.bidNumber ?? bidNumber.getFirst()
        if (this.summary.length === 0) {
          this.fetchSummary({ bidNumber: num })
        }
        this.fetchSpecifications(num)
        this.fetchCostings(num)
      },
    },
  })
</script>
